/* DE LUXE Cart Drawer V2.5 — progress never empties during Shopify Ajax updates.
   BOGOS controls real offers. Liquid draws the current state immediately;
   JavaScript synchronizes labels/thresholds and handles cart change events. */
(() => {
  'use strict';
  if (window.__dellumiaCartProgressV2) return;
  window.__dellumiaCartProgressV2 = true;

  const SELECTOR = 'cart-drawer [data-dellumia-cart-progress]';
  const CART_WRITE = /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/i;
  const BENEFITS = ['15% OFF', '20% OFF', '25% OFF', 'FREE Mystery Gift'];
  const qs = (root, selector) => root.querySelector(selector);
  const bars = () => Array.from(document.querySelectorAll(SELECTOR));
  const theme = () => document.querySelector('[data-dellumia-home-progress]');
  const config = () => document.querySelector('[data-dcp-config]');
  const enabled = (key, fallback = true) => {
    const value = config()?.getAttribute(`data-dcp-${key}`);
    return value == null ? fallback : value === 'true';
  };

  let timer = 0;
  let sequence = 0;
  let lastCart = null;

  function goals(el) {
    const src = theme();
    const fallback = (el.dataset.fallbackGoals || '65,125,175,225').split(',').map(Number);
    return fallback.map((n, i) => {
      const current = Number(src?.getAttribute(`data-goal-${i + 1}`));
      return src && Number.isFinite(current) && current > 0 ? current : n;
    });
  }
  function benefits() {
    const src = theme();
    return BENEFITS.map((fallback, i) =>
      qs(src || document, `[data-dlh-goal="${i + 1}"] .dellumia-home-progress__benefit strong`)?.textContent?.trim() || fallback
    );
  }
  function subtotalCents(cart) {
    const giftHandle = (theme()?.getAttribute('data-gift-handle') || '').trim().toLowerCase();
    if (!Array.isArray(cart.items)) return Math.max(0, Number(cart.original_total_price) || 0);
    return cart.items.reduce((sum, item) => {
      const original = Number(item.original_line_price) || 0;
      const final = Number(item.final_line_price);
      const handle = String(item.handle || item.product_handle || '').toLowerCase();
      const freeGift = (giftHandle && giftHandle === handle) || (original > 0 && final === 0);
      return sum + (freeGift ? 0 : original);
    }, 0);
  }
  function money(cents) {
    const amount = Math.max(0, cents) / 100;
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: 'USD',
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
      maximumFractionDigits: 2
    }).format(amount);
  }

  function drawValue(el, cents) {
    el.hidden = !enabled('enable');
    const amounts = goals(el);
    const rewards = benefits();
    const value = Math.max(0, Number(cents) || 0);
    let unlocked = 0;

    for (let i = 1; i <= 4; i++) {
      const goal = qs(el, `[data-dcp-goal="${i}"]`);
      if (!goal) continue;
      const reached = value >= Math.round(amounts[i - 1] * 100);
      goal.classList.toggle('is-active', reached);
      if (reached) unlocked = i;
      const threshold = qs(goal, '[data-dcp-threshold]');
      const benefit = qs(goal, '[data-dcp-benefit]');
      if (threshold) threshold.textContent = `Spend $${amounts[i - 1]} /`;
      if (benefit) benefit.textContent = rewards[i - 1];
    }

    const message = qs(el, '[data-dcp-message]');
    if (message) {
      message.hidden = !enabled('show-next');
      message.textContent = unlocked === 4
        ? 'You have unlocked all DE LUXE rewards!'
        : `You're ${money(Math.round(amounts[unlocked] * 100) - value)} away from ${rewards[unlocked]}`;
    }
    const success = qs(el, '[data-dcp-success]');
    if (success) {
      const show = enabled('show-success') && unlocked > 0;
      success.hidden = !show;
      if (show) success.textContent = `${rewards[unlocked - 1]} unlocked!`;
    }

    el.dataset.cartSubtotalCents = String(value);
    el.dataset.dcpHydrated = 'true';
    el.dataset.ready = 'true';
    el.setAttribute('aria-busy', 'false');
  }

  // Hydrate from Liquid immediately (also every newly re-rendered drawer).
  // Never temporarily mark bars inactive or show "Updating your savings…".
  function hydrateNewBars() {
    bars().forEach(el => {
      if (el.dataset.dcpHydrated === 'true') return;
      const rendered = el.getAttribute('data-cart-subtotal-cents');
      const amount = rendered !== null && rendered !== '' ? Number(rendered) : NaN;
      if (Number.isFinite(amount) && amount >= 0) drawValue(el, amount);
      else if (lastCart) drawValue(el, subtotalCents(lastCart));
    });
  }

  // Increasing generation on schedule invalidates any earlier in-flight fetch.
  function schedule(ms = 80) {
    clearTimeout(timer);
    const ticket = ++sequence;
    timer = setTimeout(() => refresh(ticket), ms);
  }
  async function refresh(ticket) {
    hydrateNewBars();
    const elements = bars();
    if (!elements.length) return;
    const root = elements[0].dataset.cartRoot || '/';
    const prefix = root.endsWith('/') ? root : `${root}/`;
    try {
      const response = await fetch(`${prefix}cart.js`, {
        credentials: 'same-origin', cache: 'no-store'
      });
      if (!response.ok) throw new Error(`Cart request: ${response.status}`);
      const cart = await response.json();
      if (ticket !== sequence) return;
      lastCart = cart;
      bars().forEach(el => drawValue(el, subtotalCents(cart)));
    } catch (error) {
      // Keep the last known correct progress on brief connection problems.
      // No reset, blank bar, busy message or lost CSS classes.
      if (ticket === sequence) console.warn('[DE LUXE Cart] Could not refresh progress:', error);
    }
  }

  function changedCart() {
    schedule(160);
    setTimeout(() => schedule(0), 750); // BOGOS may finish after Shopify.
  }
  function init() {
    hydrateNewBars();
    schedule(0);
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => schedule(80));
    }
    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:updated:drawer'].forEach(name =>
      document.addEventListener(name, () => schedule(80))
    );
    document.addEventListener('shopify:section:load', () => { hydrateNewBars(); schedule(120); });
    document.addEventListener('shopify:section:select', () => { hydrateNewBars(); schedule(120); });
    window.addEventListener('pageshow', () => schedule(80));
    window.addEventListener('focus', () => schedule(80));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(80); });

    const observer = new MutationObserver(records => {
      const affected = records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target?.closest?.(SELECTOR) || target?.closest?.('[data-dcp-config]')) return false;
        if (target?.closest?.('cart-drawer')) return true;
        return Array.from(record.addedNodes).some(node => node.nodeType === 1 &&
          (node.matches?.('cart-drawer, [data-dcp-config]') || node.querySelector?.('cart-drawer, [data-dcp-config]')));
      });
      if (!affected) return;
      // MutationObserver runs before browser paint: newly inserted bars are
      // corrected before the customer ever sees them empty.
      hydrateNewBars();
      schedule(140);
    });
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });

    if (typeof window.fetch === 'function' && !window.__dcpFetchWrapped) {
      const oldFetch = window.fetch;
      window.fetch = function(...args) {
        const request = args[0];
        const url = typeof Request !== 'undefined' && request instanceof Request
          ? request.url : String(request || '');
        const writing = CART_WRITE.test(url);
        return oldFetch.apply(this, args).then(response => {
          if (writing && response.ok) changedCart();
          return response;
        });
      };
      window.__dcpFetchWrapped = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
